<template>
	<div class="login flex align-center justify-center">
		<div style="color: #FFFFFF;width:37%;text-align: left !important;">
			<div class="font">我们的便携可靠方法</div>
			<div style="font-size: 38px;margin-top: 15px;">查学校，查专业，查双选会就用HR校招助手!</div>
			<div style="font-size: 14px;margin: 25px 0;">
				<div>全国3012所高校，2500所中专任意查。</div>
				<div style="margin:5px 0;">双选会信息及时掌握！就业办老师直接对接！校园宣讲会及时申请！</div>
				<div>合适的生源及早联络！成为您的好助手是我们永恒的追求！！</div>
			</div>
			<div class="flex align-center">
				<img src="../../assets/img/Play11.png" style="width: 100px;" />
				<div style="margin-left: 15px;">
					<div class="font">找学校</div>
					<div style="margin-top:5px ;">是什么使我们与众不同</div>
				</div>
			</div>
		</div>
		<div style="width:10%;"></div>
		<div class="content flex direction-column justify-align-center"
			style="width:25%;height:73vh;border-radius: 20px;background: #FFFFFF;">
			<div style="font-size: 22px;margin-bottom: 30px;">欢迎登录</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
				<div style="width:50px;text-align: left;">手机号</div>
			 <input type="text" v-model="tel" placeholder="请输入手机号" />
			</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0 ">
				<div style="width:50px;text-align: left;">验证码</div>
				<input type="text" v-model="code" placeholder="请输入验证码" style="width:135px" />
				<div v-if=" codes==0" @click="hqcode()" class="xiaoshou">获取验证码</div>
				<img v-if=" codes!=0" :src="srcCode" class="xiaoshou" style="width:60px;height:30px;" @click="hqcode()" />
			</div>
			<div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0 ">
		 	<div style="width:50px;text-align: left;">密码</div>
				<input :type="state" v-model="psw" placeholder="请输入密码" style="width:177px" />
				<img v-if="state=='password'" src="../../assets/img/dl2.png" style="width:15px" class="xiaoshou" @click="state='text'" />
				<img v-if="state=='text'" src="../../assets/img/dl1.png" style="width:15px" class="xiaoshou" @click="state='password'" />
			</div>
			<div style="color:#AAAAAA;width:240px;text-align: end;margin-top: 10px;" class="font xiaoshou" @click="forget()">忘记密码
			</div>
			<el-button @click="login()" :loading="buttonLoading" type="success" class="font backbg" style="margin-top: 30px; width:240px;color:#FFFFFF;">登录</el-button>
			<div class="font" style="margin-top: 20px;color:#AAAAAA;">没有账号？<span class="color xiaoshou" @click="register()">立即注册</span></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				state: 'password', //密码状态
				tel: '',
				code: '',
				psw: '',
				codes: '',
				srcCode: '', //验证码图片地址
				key: '',
				buttonLoading: false,//是否正在加载
			}
		},
		mounted() {
			if (window.localStorage.getItem('id') != '') {
				this.$store.commit('login');
			}
		},
		methods: {
			register() {
				this.$router.push('/register');
			},
			forget() {
				this.$router.push('/forget');
			},
			login() {
				if (!this.tel) return this.$message.warning('请填写手机号');
				if (!this.code) return this.$message.warning('请填写验证码');
				if (!this.psw) return this.$message.warning('请填写密码');
				this.buttonLoading = true;
				this.$axios
					.post('/api/login', {
						mobile: this.tel,
						password: this.psw,
						code: this.code,
						key: this.key
					})
					.then((res) => {
						this.buttonLoading = false;
						if (res.data.code == 200) {
							this.$store.commit('login');
							window.localStorage.setItem('token', res.data.data.api_token);
							window.localStorage.setItem('id', res.data.data.id);
							window.localStorage.setItem('name', res.data.data.name);
							this.$router.replace({
								path: '/',
								query: {
									// vip: this.$route.query.vip 
								}
							})
						}else{
							this.$message.error(res.data.msg)
						}
					});
			},
			hqcode() {
				this.codes = 1;
				this.$axios
					.get('/api/code')
					.then((res) => {
						this.srcCode = res.data.data.img;
						this.key = res.data.data.key;
					});
			}
		}
	}
</script>

<style>
	.login {
		width: 100%;
		height: 100vh;
		background-image: url(../../assets/img/de3.png);
		background-size: 100% 100%;
	}

	input {
		outline: none;
		border: none;
		padding: 10px;
		width: 190px;
	}

	input::placeholder {
		color: #AAAAAA;
		font-size: 12px;
	}
</style>
